const { getDoctorsByProblem } = require('./getDoctorsByProblem');
const { getUsersById } = require('./getUserById');

module.exports = {
  getDoctorsByProblem,
  getUsersById,
};
